import axios from "axios";

import actionTypes from "./actionTypes";
import store from "../store/store";
import { API_CONFIG } from "../../config/api.config";

const createHeaders = () => {
	const state = store.getState();
	const token = state.cms.authentication.token || localStorage.getItem("token");

	return { headers: { token } };
};

export const changeNavigation = (title) => (dispatch) => {
	dispatch({
		type: actionTypes.NAVIGATION_CHANGE,
		title,
	});
};

export const changeHead =
	({ id, title, description, showSocialMedia }) =>
	(dispatch) => {
		dispatch({
			type: actionTypes.CHANGE_HEAD,
			data: {
				id,
				title,
				description,
				showSocialMedia,
			},
		});
	};

export const setLanguage = (language) => (dispatch) => {
	const lang = language || "nl";
	localStorage.setItem("lang", lang);
	localStorage.setItem("langUuid", "489d6ac3-7b65-42c1-bdc6-67348bf7a112");
	// (store.getState().head.utilities.languages.find(lng => lng.tag === lang.toUpperCase) || { uuid: '489d6ac3-7b65-42c1-bdc6-67348bf7a112' }).uuid);

	dispatch({
		type: actionTypes.HEAD_CHANGE_LANGUAGE,
		lang,
	});
};

export const checkLanguage = () => (dispatch) => {
	const lang = localStorage.getItem("lang");

	if (!lang) {
		dispatch(setLanguage());
	}

	dispatch({
		type: actionTypes.HEAD_CHANGE_LANGUAGE,
		lang: lang || "nl",
	});
};

export const setCmsHead =
	({ title, description, buttonName = undefined, onClick = undefined }) =>
	(dispatch) => {
		dispatch({
			type: actionTypes.SET_CMS_HEAD,
			data: {
				title,
				description,
				buttonName,
				onClick,
			},
		});
	};

export const fetchLanguages = () => (dispatch) => {
	const headers = createHeaders();

	axios
		.get(`${API_CONFIG.ROUTE}${API_CONFIG.LANGUAGE}`, headers)
		.then((data) => {
			dispatch({
				type: actionTypes.FETCH_LANGUAGE,
				data: data.data.data,
			});
		});
};

export const fetchLanguageFiles = (languageUuid) => (dispatch) => {
	const headers = createHeaders();

	axios
		.get(
			`${API_CONFIG.ROUTE}${API_CONFIG.TRANSLATION}/${languageUuid}`,
			headers
		)
		.then((data) => {
			dispatch({
				type: actionTypes.FETCH_LANGUAGE_FILES,
				data: data.data,
			});
		});
};

export const consetToCookie = () => (dispatch) => {
	localStorage.setItem("consent", true);

	dispatch({
		type: actionTypes.CONSET_TO_COOKIE,
	});
};

export const checkCookieConsent = () => (dispatch) => {
	const cookie = localStorage.getItem("consent");

	dispatch({
		type: actionTypes.CHECK_CONSENT,
		consent: cookie || false,
	});
};



// WEBPACK FOOTER //
// ./src/redux/head/headActions.js